import { render, staticRenderFns } from "./ReServiceNoPurpose.vue?vue&type=template&id=26b0add2&scoped=true"
import script from "./ReServiceNoPurpose.vue?vue&type=script&lang=js"
export * from "./ReServiceNoPurpose.vue?vue&type=script&lang=js"
import style0 from "./ReServiceNoPurpose.vue?vue&type=style&index=0&id=26b0add2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b0add2",
  null
  
)

export default component.exports